import { Box, type SxProps, type Theme } from '@mui/system';

import { useTranslation } from 'react-i18next';

export const COPYRIGHT_HEIGHT = 40;

const copyrightSx: SxProps<Theme> = {
  position: 'fixed',
  bottom: '0px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '0px 20px ',
  width: '100vw',
  height: `${COPYRIGHT_HEIGHT}px`,
  fontSize: '12px',
  background: '#202123',
  color: '#FFFFFF',
  lineHeight: '14px',
};

const Copyright: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Box sx={copyrightSx}>© {t('Copyright 2023 Hoplite Technology Limited, All Rights Reserved.')}</Box>
  );
};

export default Copyright;
